import { isDate } from './is-date';

interface DateStringParserStrategy {
  parse(date: string): Date | null;
}

class YyyyMmDdParserStrategy implements DateStringParserStrategy {
  parse(date: string): Date | null {
    if (date && date.length > 0) {
      date = date.replace(/-|\//g, '');
      if (date.length === 8) {
        const year = date.substring(0, 4);
        const month = date.substring(4, 6);
        const day = date.substring(6, 8);

        if (isDate(`${year}-${month}-${day}`)) {
          return new Date(`${year}-${month}-${day}`);
        }
      }
    }
    return null;
  }
}

class MmDdYyyyParserStrategy implements DateStringParserStrategy {
  parse(date: string): Date | null {
    if (date && date.length > 0) {
      date = date.replace(/-|\//g, '');
      if (date.length === 8) {
        const year = date.substring(4, 8);
        const month = date.substring(0, 2);
        const day = date.substring(2, 4);

        if (isDate(`${year}-${month}-${day}`)) {
          return new Date(`${year}-${month}-${day}`);
        }
      }
    }
    return null;
  }
}

class DdMmYyyyParserStrategy implements DateStringParserStrategy {
  parse(date: string): Date | null {
    if (date && date.length > 0) {
      date = date.replace(/-|\//g, '');
      if (date.length === 8) {
        const year = date.substring(4, 8);
        const month = date.substring(2, 4);
        const day = date.substring(0, 2);

        if (isDate(`${year}-${month}-${day}`)) {
          return new Date(`${year}-${month}-${day}`);
        }
      }
    }
    return null;
  }
}

/**
 * @description 依國家代碼取得日期字串格式解析方式物件
 */
export class DateStringParserStrategyFactory {
  /**
   * @description 依國家代碼建立解析方式物件
   *
   * @param countryCode 國家代碼
   * @returns 日期字串格式解析方式
   */
  public static create(countryCode: string): DateStringParserStrategy {
    if (!countryCode) {
      throw Error('country code cannot be empty!');
    }
    switch (countryCode.toUpperCase()) {
      case 'MY':
      case 'KH':
      case 'ID':
        return new DdMmYyyyParserStrategy();
      case 'PH':
        return new MmDdYyyyParserStrategy();
      default:
        return new YyyyMmDdParserStrategy();
    }
  }
}

/**
 * @description 依指定方式將特定日期字串格式轉換為日期(Date)
 */
export class DateStringParser {
  private parserStrategy?: DateStringParserStrategy;

  constructor(strategy?: DateStringParserStrategy) {
    this.parserStrategy = strategy;
  }

  /**
   * @description 設定日期字串解析方式
   *
   * @param strategy 日期字串解析方式，可由 DateStringParserStrategyFactory create 方法取得。
   */
  setStrategy(strategy: DateStringParserStrategy): void {
    this.parserStrategy = strategy;
  }

  /**
   * @description 將日期字串轉換為日期(Date)
   *
   * @param date 日期字串
   * @returns 日期(Date)
   */
  doParse(date: string): Date | null {
    if (this.parserStrategy) {
      return this.parserStrategy.parse(date);
    }
    return null;
  }
}
